import { LowerCaseSearchLanguage } from '@models/CountriesAndLanguages';

export const DefaultLanguage: LowerCaseSearchLanguage = 'no';
